export const baseUrl = process.env.REACT_APP_API_BASE_URL;
export const subFolder = process.env.REACT_APP_SUB_FOLDER;

// Recordings are stored as s3:// URIs. Same conversion the web frontend uses.
//   s3://turntospeak/...  ->  https://s3.amazonaws.com/turntospeak/...
export const s3ToObjectUrl = (path) => (path ? path.replace('s3://', 'https://s3.amazonaws.com/') : '');
